// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_splice_call = require("rescript/lib/js/caml_splice_call.js");
var Expln_utils_data = require("../../rescript-utils/main/Expln_utils_data.res.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.res.js");

function isWhitespace(str) {
  if (str === " " || str === "\t" || str === "\n") {
    return true;
  } else {
    return str === "\r";
  }
}

function textAt(text, i) {
  var textLength = text.length;
  var ellipsis = (i + 20 | 0) < textLength ? "..." : "";
  return "'" + text.substr(i, 20) + ellipsis + "'";
}

function parseMmFile(text, skipCommentsOpt, skipProofsOpt, onProgressOpt) {
  var skipComments = skipCommentsOpt !== undefined ? skipCommentsOpt : false;
  var skipProofs = skipProofsOpt !== undefined ? skipProofsOpt : false;
  var onProgress = onProgressOpt !== undefined ? onProgressOpt : (function (param) {
        
      });
  var textLength = text.length;
  var idx = {
    contents: 0
  };
  var endOfFile = {
    contents: false
  };
  var ch = {
    contents: ""
  };
  var progressTracker = MM_progress_tracker.progressTrackerMake(0.1, undefined, onProgress, true);
  var allLabels = [];
  var setIdx = function (i) {
    idx.contents = i;
    if (idx.contents >= textLength) {
      endOfFile.contents = true;
      ch.contents = "";
    } else {
      endOfFile.contents = false;
      ch.contents = text.charAt(idx.contents);
    }
  };
  setIdx(0);
  var readNextChar = function () {
    if (!endOfFile.contents) {
      idx.contents = idx.contents + 1 | 0;
      if (idx.contents >= textLength) {
        endOfFile.contents = true;
        ch.contents = "";
      } else {
        ch.contents = text.charAt(idx.contents);
      }
      return ;
    }
    
  };
  var skipWhitespaces = function () {
    while(!endOfFile.contents && isWhitespace(ch.contents)) {
      readNextChar();
    };
  };
  var readAllTextTill = function (tillToken) {
    var result;
    var resultIsReady = false;
    var beginIdx = idx.contents;
    while(!resultIsReady) {
      var foundIdx = text.indexOf(tillToken, idx.contents);
      if (foundIdx < 0) {
        resultIsReady = true;
      } else {
        var nextIdx = foundIdx + tillToken.length | 0;
        setIdx(nextIdx);
        if (endOfFile.contents || isWhitespace(ch.contents)) {
          result = text.substring(beginIdx, foundIdx);
          resultIsReady = true;
        } else {
          setIdx(foundIdx + 1 | 0);
        }
      }
    };
    return result;
  };
  var parseComment = function (beginIdx) {
    var commentText = readAllTextTill("$)");
    if (commentText !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: "Comment",
                text: commentText
              }
            };
    }
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "A comment is not closed at " + textAt(text, beginIdx)
          },
          Error: new Error()
        };
  };
  var readNextToken = function (skipComments) {
    if (skipComments) {
      var nextToken = readNextToken(false);
      while(nextToken === "$(") {
        parseComment(idx.contents);
        nextToken = readNextToken(false);
      };
      return nextToken;
    }
    skipWhitespaces();
    var beginIdx = idx.contents;
    while(!endOfFile.contents && !isWhitespace(ch.contents)) {
      readNextChar();
    };
    return text.substring(beginIdx, idx.contents);
  };
  var readAllTokensTill = function (tillToken) {
    var result;
    var resultIsReady = false;
    var tokens = [];
    while(!resultIsReady) {
      var token = readNextToken(true);
      if (token === "") {
        resultIsReady = true;
      } else if (token === tillToken) {
        result = tokens;
        resultIsReady = true;
      } else {
        tokens.push(token);
      }
    };
    return result;
  };
  var parseConst = function (beginIdx) {
    var tokens = readAllTokensTill("$.");
    if (tokens !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: "Const",
                symbols: tokens
              }
            };
    }
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "A constant statement is not closed at " + textAt(text, beginIdx)
          },
          Error: new Error()
        };
  };
  var parseVar = function (beginIdx) {
    var tokens = readAllTokensTill("$.");
    if (tokens !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: "Var",
                symbols: tokens
              }
            };
    }
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "A variable statement is not closed at " + textAt(text, beginIdx)
          },
          Error: new Error()
        };
  };
  var parseDisj = function (beginIdx) {
    var tokens = readAllTokensTill("$.");
    if (tokens !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: "Disj",
                vars: tokens
              }
            };
    }
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "A disjoint statement is not closed at " + textAt(text, beginIdx)
          },
          Error: new Error()
        };
  };
  var parseFloating = function (beginIdx, label) {
    var tokens = readAllTokensTill("$.");
    if (tokens !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: "Floating",
                label: label,
                expr: tokens
              }
            };
    }
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "A floating statement is not closed at " + textAt(text, beginIdx)
          },
          Error: new Error()
        };
  };
  var parseEssential = function (beginIdx, label) {
    var tokens = readAllTokensTill("$.");
    if (tokens !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: "Essential",
                label: label,
                expr: tokens
              }
            };
    }
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "An essential statement is not closed at " + textAt(text, beginIdx)
          },
          Error: new Error()
        };
  };
  var parseAxiom = function (beginIdx, label) {
    var tokens = readAllTokensTill("$.");
    if (tokens !== undefined) {
      return {
              begin: beginIdx,
              end: idx.contents - 1 | 0,
              stmt: {
                TAG: "Axiom",
                label: label,
                expr: tokens
              }
            };
    }
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "An axiom statement is not closed at " + textAt(text, beginIdx)
          },
          Error: new Error()
        };
  };
  var parseProvable = function (beginIdx, label) {
    var expression = readAllTokensTill("$=");
    if (expression !== undefined) {
      var firstProofToken = readNextToken(true);
      if (firstProofToken === "(") {
        var proofLabels = readAllTokensTill(")");
        if (proofLabels !== undefined) {
          var compressedProofBlocks = readAllTokensTill("$.");
          if (compressedProofBlocks !== undefined) {
            return {
                    begin: beginIdx,
                    end: idx.contents - 1 | 0,
                    stmt: {
                      TAG: "Provable",
                      label: label,
                      expr: expression,
                      proof: skipProofs ? undefined : ({
                            TAG: "Compressed",
                            labels: proofLabels,
                            compressedProofBlock: Caml_splice_call.spliceObjApply("", "concat", [compressedProofBlocks])
                          })
                    }
                  };
          }
          throw {
                RE_EXN_ID: Common.MmException,
                _1: {
                  msg: "A probale statement is not closed[3] at " + textAt(text, beginIdx)
                },
                Error: new Error()
              };
        }
        throw {
              RE_EXN_ID: Common.MmException,
              _1: {
                msg: "A provable statement is not closed[2] at " + textAt(text, beginIdx)
              },
              Error: new Error()
            };
      }
      var proofLabels$1 = readAllTokensTill("$.");
      if (proofLabels$1 !== undefined) {
        return {
                begin: beginIdx,
                end: idx.contents - 1 | 0,
                stmt: {
                  TAG: "Provable",
                  label: label,
                  expr: expression,
                  proof: skipProofs ? undefined : ({
                        TAG: "Uncompressed",
                        labels: [firstProofToken].concat(proofLabels$1)
                      })
                }
              };
      }
      throw {
            RE_EXN_ID: Common.MmException,
            _1: {
              msg: "A provable statement is not closed[4] at " + textAt(text, beginIdx)
            },
            Error: new Error()
          };
    }
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "A provable statement is not closed[1] at " + textAt(text, beginIdx)
          },
          Error: new Error()
        };
  };
  var parseBlock = function (beginIdx, level) {
    var result;
    var statements = [];
    while(Belt_Option.isNone(result)) {
      var token = readNextToken(false);
      var tokenIdx = idx.contents - token.length | 0;
      if (token === "") {
        if (level === 0) {
          result = {
            begin: beginIdx,
            end: idx.contents - 1 | 0,
            stmt: {
              TAG: "Block",
              level: level,
              statements: statements
            }
          };
        } else {
          throw {
                RE_EXN_ID: Common.MmException,
                _1: {
                  msg: "Unexpected end of a block. The block begins at " + textAt(text, beginIdx) + " and is not closed."
                },
                Error: new Error()
              };
        }
      } else if (token === "$}") {
        result = {
          begin: beginIdx,
          end: idx.contents - 1 | 0,
          stmt: {
            TAG: "Block",
            level: level,
            statements: statements
          }
        };
      } else if (token === "${") {
        var stmt = parseBlock(tokenIdx, level + 1 | 0);
        statements.push(stmt);
      } else if (token === "$(") {
        var comment = parseComment(tokenIdx);
        if (!skipComments) {
          statements.push(comment);
        }
        
      } else if (token === "$[") {
        readAllTextTill("$]");
      } else if (token === "$c") {
        var stmt$1 = parseConst(tokenIdx);
        statements.push(stmt$1);
      } else if (token === "$v") {
        var stmt$2 = parseVar(tokenIdx);
        statements.push(stmt$2);
      } else if (token === "$d") {
        var stmt$3 = parseDisj(tokenIdx);
        statements.push(stmt$3);
      } else {
        var token2 = readNextToken(true);
        var token2Idx = idx.contents - token2.length | 0;
        if (token2 === "") {
          throw {
                RE_EXN_ID: Common.MmException,
                _1: {
                  msg: "Unexpected end of file at " + textAt(text, tokenIdx)
                },
                Error: new Error()
              };
        }
        if (token2 === "$f") {
          var stmt$4 = parseFloating(tokenIdx, token);
          statements.push(stmt$4);
        } else if (token2 === "$e") {
          var stmt$5 = parseEssential(tokenIdx, token);
          statements.push(stmt$5);
        } else if (token2 === "$a") {
          allLabels.push(token);
          var stmt$6 = parseAxiom(tokenIdx, token);
          statements.push(stmt$6);
        } else if (token2 === "$p") {
          allLabels.push(token);
          var stmt$7 = parseProvable(tokenIdx, token);
          statements.push(stmt$7);
        } else {
          throw {
                RE_EXN_ID: Common.MmException,
                _1: {
                  msg: "Unexpected token '" + token2 + "' at " + textAt(text, token2Idx)
                },
                Error: new Error()
              };
        }
      }
      MM_progress_tracker.progressTrackerSetCurrPct(progressTracker, tokenIdx / textLength);
    };
    return Belt_Option.getExn(result);
  };
  var rootAst = parseBlock(idx.contents, 0);
  return [
          rootAst,
          allLabels
        ];
}

function traverseAst(context, root, preProcess, $$process, postProcess) {
  return Expln_utils_data.traverseTree(context, root, (function (param, node) {
                var match = node.stmt;
                if (match.TAG === "Block") {
                  return match.statements;
                }
                
              }), preProcess, $$process, postProcess);
}

function proofToStr(proof) {
  if (proof !== undefined) {
    if (proof.TAG === "Uncompressed") {
      return proof.labels.join(" ");
    } else {
      return "( " + proof.labels.join(" ") + " ) " + proof.compressedProofBlock;
    }
  } else {
    return "?";
  }
}

function stmtToStr(node) {
  var match = node.stmt;
  switch (match.TAG) {
    case "Comment" :
        return "$( " + match.text + " $)";
    case "Const" :
        return "$c " + match.symbols.join(" ") + " $.";
    case "Block" :
        return "block(level=" + String(match.level) + ")";
    case "Var" :
        return "$v " + match.symbols.join(" ") + " $.";
    case "Disj" :
        return "$d " + match.vars.join(" ") + " $.";
    case "Floating" :
        return match.label + " $f " + match.expr.join(" ") + " $.";
    case "Essential" :
        return match.label + " $e " + match.expr.join(" ") + " $.";
    case "Axiom" :
        return match.label + " $a " + match.expr.join(" ") + " $.";
    case "Provable" :
        return match.label + " $p " + match.expr.join(" ") + " $= " + proofToStr(match.proof) + " $.";
    
  }
}

function stmtToStrRec(stmt) {
  var match = traverseAst([
        {
          contents: 0
        },
        []
      ], stmt, (function (param, node) {
          var level = param[0];
          var match = node.stmt;
          if (match.TAG === "Block") {
            var newLevel = match.level;
            if (newLevel !== 0) {
              param[1].push("    ".repeat(level.contents) + "${");
            }
            level.contents = newLevel;
          }
          
        }), (function (param, node) {
          var str;
          str = node.stmt.TAG === "Block" ? "" : stmtToStr(node);
          if (str !== "") {
            param[1].push("    ".repeat(param[0].contents) + str);
          }
          
        }), (function (param, node) {
          var level = param[0];
          var match = node.stmt;
          if (match.TAG === "Block") {
            var newLevel = match.level;
            level.contents = newLevel - 1 | 0;
            if (newLevel !== 0) {
              param[1].push("    ".repeat(level.contents) + "$}");
            }
            
          }
          
        }));
  return match[0][1];
}

function astToStr(ast) {
  var res = [];
  traverseAst(undefined, ast, (function (param, node) {
          var match = node.stmt;
          if (match.TAG === "Block") {
            if (match.level > 0) {
              res.push("${");
            }
            
          }
          
        }), (function (param, node) {
          var match = node.stmt;
          switch (match.TAG) {
            case "Comment" :
                res.push("$( " + match.text + " $)");
                break;
            case "Const" :
                var str = "$c " + match.symbols.join(" ") + " $.";
                res.push(str);
                break;
            case "Block" :
                break;
            case "Var" :
                var str$1 = "$v " + match.symbols.join(" ") + " $.";
                res.push(str$1);
                break;
            case "Disj" :
                var str$2 = "$d " + match.vars.join(" ") + " $.";
                res.push(str$2);
                break;
            case "Floating" :
                var str$3 = match.label + " $f " + match.expr.join(" ") + " $.";
                res.push(str$3);
                break;
            case "Essential" :
                var str$4 = match.label + " $e " + match.expr.join(" ") + " $.";
                res.push(str$4);
                break;
            case "Axiom" :
                var str$5 = match.label + " $a " + match.expr.join(" ") + " $.";
                res.push(str$5);
                break;
            case "Provable" :
                var str$6 = match.label + " $p " + match.expr.join(" ") + " $= " + proofToStr(match.proof) + " $.";
                res.push(str$6);
                break;
            
          }
        }), (function (param, node) {
          var match = node.stmt;
          if (match.TAG === "Block") {
            if (match.level > 0) {
              res.push("$}");
            }
            
          }
          
        }));
  return res.join("\n");
}

exports.parseMmFile = parseMmFile;
exports.textAt = textAt;
exports.traverseAst = traverseAst;
exports.stmtToStr = stmtToStr;
exports.stmtToStrRec = stmtToStrRec;
exports.astToStr = astToStr;
exports.isWhitespace = isWhitespace;
/* Common Not a pure module */
